import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Loader2 } from "lucide-react";
import AuthShell from "../components/AuthShell";
import PhoneInput from "../components/PhoneInput";
import { useAuth } from "../context/AuthContext";

export default function PhoneCapture() {
  const { user, sendPhoneOtp } = useAuth();
  const navigate = useNavigate();
  const [phoneInfo, setPhoneInfo] = useState({
    countryCode: "KE",
    phone: "",
    dial: "254",
    e164: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const digits = String(phoneInfo.phone || "").replace(/\D/g, "");
    if (digits.length < 6) {
      setError("Please enter a valid phone number");
      return;
    }
    setLoading(true);
    await sendPhoneOtp(phoneInfo);
    setLoading(false);
    navigate("/phone/verify");
  };

  return (
    <AuthShell
      title="Add your phone number"
      subtitle={
        <>
          Welcome{user?.fullName ? `, ${user.fullName.split(" ")[0]}` : ""}. We'll send a
          verification code to confirm this number.
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="label-base">Phone number</label>
          <PhoneInput
            countryCode={phoneInfo.countryCode}
            phone={phoneInfo.phone}
            onChange={setPhoneInfo}
          />
        </div>
        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}
        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Phone className="h-4 w-4" />
          )}
          Send verification code
        </button>
      </form>
    </AuthShell>
  );
}
